var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNftSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15744",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15744",
    transform: "translate(18724 -6106)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_4776",
    "data-name": "\\u6955\\u5186\\u5F62 4776",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(-18724 6106)",
    fill: "#414141",
    opacity: 0.486
  }), /*#__PURE__*/React.createElement("g", {
    id: "Checkmark",
    transform: "translate(-18712.023 6122.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action"
  }, /*#__PURE__*/React.createElement("path", {
    id: "action_049-checkmark-done-check-finish",
    d: "M413.52,243.02v-10a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v7.5h13.5a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5h-16A.5.5,0,0,1,413.52,243.02Z",
    transform: "translate(-449.699 143.128) rotate(-45)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftSelected);
export default __webpack_public_path__ + "static/media/nftSelected.118e4af330c53d90a18fa465b5d173a3.svg";
export { ForwardRef as ReactComponent };